import { NotificationSettings } from './notification-settings';
import { OutlookConnectSettings } from './outlook-connect-settings';

/**
 * Dedicated settings panel component for chat area.
 * Displays settings content inline within the main chat content area
 * instead of as a modal dialog overlay. Matches the styling of the original dialog.
 */
export function ChatSettingsPanel() {
  return (
    <div className="flex size-full min-w-0 flex-col">
      {/* Settings Content */}
      <div className="flex flex-1 items-start justify-center p-6">
        <div className="bg-background border-border flex w-full max-w-md flex-col gap-4 rounded-sm border px-6 py-2">
          <NotificationSettings />
          <OutlookConnectSettings />
        </div>
      </div>
    </div>
  );
}
